import { useOrganization } from "~/hooks/useOrganization"
import { api } from "~/trpc/react"

export function CustomEmoji({
	id,
	name,
	organizationId
}: {
	id: string
	name: string
	organizationId?: string
}) {
	const { organization } = useOrganization()
	const allowed =
		!!organization && (!organizationId || organization.id === organizationId)
	const emojis = api.emojis.list.useQuery(
		{ organizationId: organization?.id ?? "" },
		{ enabled: allowed, staleTime: 30000, refetchInterval: 60000 }
	)
	const emoji = allowed
		? emojis.data?.find((entry) => entry.id === id)
		: undefined
	return emoji ? (
		<img
			src={emoji.image}
			alt={`:${emoji.name}:`}
			title={`:${emoji.name}:`}
			className="inline-block size-5 shrink-0 object-contain align-text-bottom"
			draggable={false}
		/>
	) : (
		<span>:{name}:</span>
	)
}
